function LoadView(view) {
  return () =>
    import(
      /* webpackChunkName: "view-[request]" */ `@/html/subpage/prepayment/${view}.vue`
    );
}

const prepaymentRoutes = [
  // 사전결제 - 안내
  {
    path: '/prepaymentinfo',
    name: 'prepaymentinfo',
    component: LoadView('prepaymentInfo'),
    meta: {
      category: ['사전결제', '사전결제 안내'],
    },
  },
  // 사전결제 - 조회
  {
    path: '/prepaymentsearch',
    name: 'prepaymentsearch',
    component: LoadView('prepaymentSearch'),
    meta: {
      category: ['사전결제', '요금 조회/결제'],
    },
  },
  // 사전결제 - 상세
  {
    path: '/prepaymentview',
    name: 'prepaymentview',
    component: LoadView('prepaymentView'),
    meta: {
      category: ['사전결제', '요금 조회/결제'],
    },
  },
];

export default prepaymentRoutes;
